var React = require('react');

function Campaigns (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"50","height":"50","rx":"10","fill":"none","key":0}),React.createElement("path",{"d":"M11.2326 37C10.662 37 10.1473 36.7688 9.68837 36.3063C9.22946 35.8438 9 35.325 9 34.75V15.25C9 14.675 9.22946 14.1562 9.68837 13.6938C10.1473 13.2313 10.662 13 11.2326 13H21.6884L23.9209 15.25H36.5349C37.1054 15.25 37.6202 15.4813 38.0791 15.9438C38.538 16.4063 38.7674 16.925 38.7674 17.5H22.9535L20.7209 15.25H11.2326V34.75L15.0279 19.75H41L37.0186 35.275C36.8698 35.875 36.5969 36.3125 36.2 36.5875C35.8031 36.8625 35.2946 37 34.6744 37H11.2326ZM13.5767 34.75H34.8605L37.986 22H16.7023L13.5767 34.75Z","fill":"#F28721","key":1})]);
}

Campaigns.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none"};

module.exports = Campaigns;

Campaigns.default = Campaigns;
